import React, { useEffect, useState,useContext } from 'react';
import { useParams,Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { CartContext } from '../../context/CartContext';
import VendorProductCard from '../../components/VendorProductCard';
import { useProductVendor } from '../../context/ProductVendorContext';

const ProductosVendedorPage = () => {
  const { userId } = useParams();
  // const [products, setProducts] = useState([]);
  // const [loading, setLoading] = useState(true);
    const { user } = useAuth();
  const { state, addToCart } = useContext(CartContext);
    const { fetchVendorProducts,products,loading,editVendorProduct } = useProductVendor();
 
  useEffect(() => {
    if (userId) {
      fetchVendorProducts(userId);
    }
  }, [userId, fetchVendorProducts]);

  if (loading) return <p>Cargando productos...</p>;

  return (
    <div>
      <h2>Productos del {user.vendor_name}</h2>
      <Link to="/vendor">Regresar al menú de opciones</Link>
      {products.length === 0 ? (
        <p>No hay productos para este vendedor.</p>
      ) : (
        <>
          <section className="py-1">
            <div className="container px-4 px-lg-5 mt-5">
              <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-4 justify-content-center">
                {products.map(product => (
                  <VendorProductCard key={product.id} product={product} addToCart={addToCart} />
                ))}
              </div>
            </div>
          </section>        
        </>

      )}
    </div>
  );
};

export default ProductosVendedorPage;
